import { Component, computed, inject, input } from '@angular/core';
import type { HomeBatteryCapacityAdviceFields } from '@feh/homebattery-models';
import { TextInterpolationService } from '@core/jss-utils';
import capitalize from 'lodash/capitalize';
import type { RenderingField } from '@sitecore-jss/sitecore-jss-angular';
import { RichTextWrapperComponent } from '@legacy/common-ui-utility-components';

@Component({
  selector: 'wl-homebattery-usage-capacity-breakdown',
  standalone: true,
  imports: [RichTextWrapperComponent],
  templateUrl: './homebattery-usage-capacity-breakdown.component.html',
  styleUrls: [
    './homebattery-usage-capacity-breakdown.component.ed.scss',
    './homebattery-usage-capacity-breakdown.component.essent.scss',
  ],
})
export class HomebatteryUsageCapacityBreakdownComponent {
  public readonly fields = input.required<HomeBatteryCapacityAdviceFields>();
  public readonly energyCapacity = input.required<number>();
  private readonly interpolationService = inject(TextInterpolationService);

  private getUsageCycle(energyCapacity: number): string {
    switch (energyCapacity) {
      case 5:
        return '1';
      case 10:
        return '2';
      case 15:
        return '3';
      default:
        return '';
    }
  }

  private getWashText(energyCapacity: number): string {
    return energyCapacity === 5 ? 'wasje' : 'wasjes';
  }

  protected readonly breakdownTextValues = computed(() => {
    const renderingFields = this.fields();
    const energyCapacity = this.energyCapacity();
    const usageCycle = this.getUsageCycle(energyCapacity);

    return this.interpolationService.interpolate(
      renderingFields.Usps,
      {
        washText: this.getWashText(energyCapacity),
        usageCycle: capitalize(usageCycle),
      },
      'plain_text'
    ) as RenderingField<string>;
  });

  protected readonly titleText = computed(() => {
    const energyCapacity = this.energyCapacity();
    return this.interpolationService.interpolate(
      this.fields().CapacityBreakdownTitleText,
      { energyCapacity: `${energyCapacity}kWh` },
      'plain_text'
    );
  });
}
